import { Moment } from "moment";
import { SituacaoUpload } from "./enum";
import OperacaoInternacional from "./operacaoInternacional";
import { DocumentReference } from "firebase/firestore";

export default class UploadInternacional implements IUploadInternacional {
  public id!: string;
  public nomeArquivoOriginal!: string;
  public situacao!: SituacaoUpload;
  public dataUpload?: Moment;
  public arquivo?: string;
  public periodo?: Periodo;
  // Instituição financeira a que a operação pertence (ex.: Pictet, XP)
  public instituicao?: string;
  // Operações brutas do reader (antes de enriquecer) OU vazias após enriquecimento
  public operacoes?: OperacaoInternacional[];
  // Referências às operações importadas (enriquecidas)
  public operacoesImportadas?: DocumentReference[];
  // Linhas já existentes em outro statement da mesma instituição, descartadas na importação
  public operacoesIgnoradas?: number;
  public erro?: any;

  constructor(param: IUploadInternacional) {
    Object.assign(this, param);
  }
}

export interface IUploadInternacional {
  id: string;
  nomeArquivoOriginal: string;
  situacao: SituacaoUpload;
  dataUpload?: Moment;
  arquivo?: string;
  periodo?: Periodo;
  instituicao?: string;
  operacoes?: OperacaoInternacional[];
  operacoesImportadas?: DocumentReference[];
  operacoesIgnoradas?: number;
  erro?: any;
}

export interface Periodo {
  de: Moment;
  a: Moment;
}
